import React from 'react';

// Lightweight inline icon set for Game Accelerator
// Stroke-based, currentColor — pairs well with the glow chips.

const Icon = ({ children, size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    {children}
  </svg>
);

const Icons = {
  Bolt: (p) => (
    <Icon {...p}><path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" /></Icon>
  ),
  Shield: (p) => (
    <Icon {...p}><path d="M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6l8-3z" /><path d="M9 12l2 2 4-4" /></Icon>
  ),
  Globe: (p) => (
    <Icon {...p}><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c2.5 3 2.5 15 0 18M12 3c-2.5 3-2.5 15 0 18" /></Icon>
  ),
  Cpu: (p) => (
    <Icon {...p}><rect x="5" y="5" width="14" height="14" rx="2" /><rect x="9" y="9" width="6" height="6" /><path d="M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3" /></Icon>
  ),
  Wifi: (p) => (
    <Icon {...p}><path d="M2 9c5.5-5 14.5-5 20 0M5 12.5c3.5-3 10.5-3 14 0M8.5 16c1.5-1.2 5.5-1.2 7 0" /><circle cx="12" cy="19.5" r="1" fill="currentColor" /></Icon>
  ),
  Activity: (p) => (
    <Icon {...p}><path d="M2 12h4l3-8 6 16 3-8h4" /></Icon>
  ),
  Lock: (p) => (
    <Icon {...p}><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 018 0v4" /></Icon>
  ),
  Layers: (p) => (
    <Icon {...p}><path d="M12 3l9 5-9 5-9-5 9-5z" /><path d="M3 13l9 5 9-5M3 18l9 5 9-5" /></Icon>
  ),
  Settings: (p) => (
    <Icon {...p}><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1-1.5 1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1a1.7 1.7 0 001.5-1 1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.8.3h0a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5h0a1.7 1.7 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.8v0a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z" /></Icon>
  ),
  Monitor: (p) => (
    <Icon {...p}><rect x="3" y="4" width="18" height="12" rx="2" /><path d="M8 21h8M12 16v5" /></Icon>
  ),
  Console: (p) => (
    <Icon {...p}><path d="M6 8h12a4 4 0 014 4v4a3 3 0 01-5.2 2L15 16H9l-1.8 2A3 3 0 012 16v-4a4 4 0 014-4z" /><path d="M8 12v3M6.5 13.5h3M15 13h.01M17 14h.01" /></Icon>
  ),
  Mobile: (p) => (
    <Icon {...p}><rect x="7" y="2" width="10" height="20" rx="2.5" /><path d="M11 18h2" /></Icon>
  ),
  Mac: (p) => (
    <Icon {...p}><rect x="2" y="4" width="20" height="13" rx="1.5" /><path d="M2 17l-1 3h22l-1-3" /></Icon>
  ),
  Apple: (p) => (
    <Icon {...p} fill="currentColor" stroke="none">
      <path d="M16.4 12.5c0-2.4 2-3.5 2.1-3.6-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.7.9-.8 0-1.9-.9-3.2-.8-1.6 0-3.1.9-3.9 2.4-1.7 2.9-.4 7.2 1.2 9.5.8 1.1 1.8 2.4 3.1 2.4 1.2-.1 1.7-.8 3.2-.8s1.9.8 3.2.8c1.3 0 2.2-1.2 3-2.3.9-1.3 1.3-2.6 1.4-2.6-.1 0-2.7-1-2.7-4z"/>
      <path d="M14 5.4c.7-.8 1.1-2 1-3.2-1 0-2.2.7-2.9 1.5-.6.7-1.2 1.9-1 3.1 1.1.1 2.2-.6 2.9-1.4z"/>
    </Icon>
  ),
  Android: (p) => (
    <Icon {...p} fill="currentColor" stroke="none">
      <path d="M5.5 10.5c-.6 0-1 .4-1 1v5c0 .6.4 1 1 1s1-.4 1-1v-5c0-.6-.4-1-1-1zM18.5 10.5c-.6 0-1 .4-1 1v5c0 .6.4 1 1 1s1-.4 1-1v-5c0-.6-.4-1-1-1zM7.5 18c0 .6.4 1 1 1h.5v2.5c0 .6.4 1 1 1s1-.4 1-1V19h2v2.5c0 .6.4 1 1 1s1-.4 1-1V19h.5c.6 0 1-.4 1-1v-7.5h-9V18z"/>
      <path d="M15.4 5.6l1-1.7c.1-.2 0-.4-.1-.5-.2-.1-.4 0-.5.1l-1 1.8c-.9-.4-1.8-.6-2.8-.6-1 0-2 .2-2.8.6l-1-1.8c-.1-.2-.3-.2-.5-.1-.2.1-.2.3-.1.5l1 1.7c-1.7 1-2.9 2.7-3.1 4.7h13c-.2-2-1.4-3.7-3.1-4.7zM9.5 8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm5 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5z"/>
    </Icon>
  ),
  Check: (p) => (
    <Icon {...p}><path d="M5 12l4 4L19 6" /></Icon>
  ),
  ArrowRight: (p) => (
    <Icon {...p}><path d="M5 12h14M13 6l6 6-6 6" /></Icon>
  ),
  Star: (p) => (
    <Icon {...p}><path d="M12 3l2.7 5.7 6.3.9-4.5 4.4 1 6.3L12 17.8 6.5 20.3l1-6.3L3 9.6l6.3-.9L12 3z" /></Icon>
  ),
  Download: (p) => (
    <Icon {...p}><path d="M12 3v12M7 10l5 5 5-5M5 21h14" /></Icon>
  ),
};

export default Icons;
